<template>
  <div class="col-lg clr2 py-4">
    <h1 class="py-3 px-5 display-4 text-light">Portfolio</h1>
  </div>
  
  <h1 class="text-center display-1">Current Funds: ${{ Math.round(networth *100)/100}}</h1>

	<div id="stockDisplay">
		<PortfolioStock 	v-for="stock in stocks"  :key="stock" class="stock"
				:channel="this.stockDataBase[stock].channel" id="stock"
				:price="Math.round((((this.stockDataBase[stock].subs*0.676)+(this.stockDataBase[stock].viewLikeRatio-0.1)*5000000)/10000) * 100) / 100" 
				:change="Math.round((((this.stockDataBase[stock].subs*0.676)+(this.stockDataBase[stock].viewLikeRatio-0.1)*5000000)/10000-this.stockDataBase[stock].prevPrice) * 100) / 100" 
				:changePercent="Math.round((((((this.stockDataBase[stock].subs*0.676)+(this.stockDataBase[stock].viewLikeRatio-0.1)*5000000)/10000-this.stockDataBase[stock].prevPrice)/this.stockDataBase[stock].prevPrice)*100) * 100) / 100" 
				:logo="this.stockDataBase[stock].abbrev"
				:subs="this.stockDataBase[stock].subs" 
				:viewLikeRatio="this.stockDataBase[stock].viewLikeRatio"
				:shares="this.shares[this.stocks.indexOf(stock)]"
				/>
	</div>
</template>

<script>
import PortfolioStock from '../components/PortfolioStock.vue'
import { getDatabase, ref, child, get, onValue} from "firebase/database";
import {
  getFirestore,
  collection,
  doc,
  setDoc,
  getDoc,
  exists,
} from "firebase/firestore";

export default {
  data() {
    return {
      db: getFirestore(this.$app),
      uid: this.$route.params.uid,
      networth: 0,
      lastDayLoggedIn: [],
      stocks: [],
	  shares: [],
	  stockDataBase:{}
    };
  },
  components: {
	PortfolioStock
  },
  methods: {},
  mounted() {

	const db = getDatabase()
		const stocksRef = ref(db, 'Stocks');
		onValue(stocksRef, (snapshot) => {
  			const data = snapshot.val();
  			this.stockDataBase = data;
		});


    const docRef = doc(this.db, "users", this.uid);
    getDoc(docRef)
      .then((docSnap) => {
        if (!docSnap.exists()) {
          console.log("no uid doc yet");
          setDoc(doc(this.db, "users", this.uid), {
            networth: 20000,
            lastDayLoggedIn: [new Date().getDate(), new Date().getMonth() + 1],
            stocks: [],
			shares: [],
          })
            .then(() => {})
            .catch((error) => {
              console.log(error.message);
            });
        } else {
          console.log("havedata");
          getDoc(docRef)
            .then((docSnap) => {
              this.networth = docSnap.data().networth;
              this.lastDayLoggedIn = docSnap.data().lastDayLoggedIn;
              this.stocks = docSnap.data().stocks;
			  this.shares = docSnap.data().shares;
            })
            .catch((error) => {
              console.log(error.message);
            });
			
        }
      })
      .catch((error) => {
        const errorMessage = error.message;
        console.log(errorMessage);
      });
  }
}
</script>
<style>
  body {
    margin: 0px;
  }
  .clr2{
		background-color: #2A6A91;
	}
#stockDisplay{
		display: flex;
		flex-flow: wrap;
		justify-content: left;
		background-color: #57AADE
	}
	.stock {
		padding-left: 50px;
		padding-right: 40px;
		padding-top: 50px;
		padding-bottom: 50px;
		margin-top: 50px;
		margin-left: 25px;
		margin-right: 25px;
		border-radius: 25px;
        border: 4px solid #292626;
		background-color: #292626;
	}
	.clr{
		background-color: #F8F9FA
	}
	.clr2{
		background-color: #2A6A91;
	}
</style>
